import React, { Component } from 'react';
import {
    Table, Icon, Divider, Button, Popconfirm,
} from 'antd';
import MachineTimersAddContainer from '../containers/MachineTimersAddContainer';
import constants from '../../constants';

class MachineTimersListView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
            timerId: null,
        };
        this.onCancel = this.onCancel.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    onCancel() {
        this.closeForm();
    }

    onDelete(id) {
        this.props.deleteLog(id);
    }


    confirm(e) {
        console.log(e);
        this.onDelete(e);
    }

    cancel(e) {
        console.log(e);
        // message.error('Click en ');
    }

    closeForm() {
        this.setState({
            openForm: false,
        });
    }

    render() {
        let columns = [
            {
                title: 'Date',
                dataIndex: 'createdtime',
                key: 'createdtime',
                render: text => (new Date(text).toDateString()),
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Days Left',
                dataIndex: 'daysleft',
                key: 'daysleft',
            },
            {
                title: 'Author',
                dataIndex: 'author',
                key: 'author',
            },
        ];

        if (this.props.extraUser.type === constants.ADMIN_ROLE
            || this.props.extraUser.type === constants.SADMIN_ROLE
            || this.props.extraUser.type === constants.SUPV_ROLE) {
            columns = columns.concat({
                title: 'Options',
                key: 'action',
                render: (text, row) => (
                    <span>
                        <Button
                            onClick={() => {
                                this.setState({ openForm: true, timerId: row.key });
                            }}
                        >
                            <Icon type="edit" />
                        </Button>
                        <Divider type="vertical" />
                        <Popconfirm title="Estas seguro que deseas eliminar este Timer?" onConfirm={this.confirm.bind(this, row.key)} onCancel={this.cancel} okText="Si" cancelText="No" > 
                            <Button>
                                <Icon type="delete" />
                            </Button>
                        </Popconfirm>
                    </span>
                ),
            });
        }

        const addTimerBtn = (
            <Button type="primary lg col-md-4 center-block" onClick={() => { this.setState({ openForm: true, timerId: null }); }}>
                Add New Timer
            </Button>
        );
        return (
            <div>
                <Table
                    columns={columns}
                    expandedRowRender={record => (
                        <p style={{ margin: 0 }}>
                            {record.description}
                        </p>
                    )}
                    dataSource={this.props.timers}
                />
                {this.props.extraUser.type === constants.SADMIN_ROLE && addTimerBtn}
                {this.props.extraUser.type === constants.ADMIN_ROLE && addTimerBtn}
                {this.props.extraUser.type === constants.SUPV_ROLE && addTimerBtn}
                {this.props.extraUser.type === constants.TEC_ROLE && addTimerBtn}
                <MachineTimersAddContainer
                    openForm={this.state.openForm}
                    closeForm={this.closeForm}
                    onCancel={this.onCancel}
                    timerId={this.state.timerId}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                    machineId={this.props.machineId}
                />
            </div>
        );
    }
}

export default MachineTimersListView;



// WEBPACK FOOTER //
// ./src/components/views/MachineTimersListView.js